import { Stack } from "@mui/material";
// components
import {
  TopContent,
  RecentContent,
  ContentPreview,
} from "../../../components/Discover/details";
import { useSelector } from "react-redux";
import { useEffect, useRef } from "react";
// config

const ContentTab = ({
  topContent = [],
  wishlink_username,
  instagram_username,
}) => {
  const selectedContent = useSelector((s) => s.creator.selectedContent);
  const previewRef = useRef(null);

  useEffect(() => {
    if (!selectedContent) return;

    // wait for ContentPreview to mount, then scroll
    requestAnimationFrame(() => {
      previewRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    });
  }, [selectedContent]);

  return (
    <>
      <Stack gap={3} flex={1}>
        <ContentPreview previewRef={previewRef} />

        <TopContent
          topContent={topContent}
          wishlink_username={wishlink_username}
          instagram_username={instagram_username}
        />
        <RecentContent
          wishlink_username={wishlink_username}
          instagram_username={instagram_username}
        />
      </Stack>
    </>
  );
};

export default ContentTab;
